export default __webpack_public_path__ + "static/media/undraw_asset_selection_re_k5fj.d74452bd.svg";